"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _Initialize = _interopRequireDefault(require("./Initialize"));

var Parser = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Parser, _Component);

  function Parser() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleReady", function (api) {
      _this.setState({
        api: api
      }, _this.handleParse);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleContainer", function (container) {
      _this.setState({
        container: container
      }, _this.handleParse);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleParse", function () {
      var _this$state = _this.state,
          api = _this$state.api,
          container = _this$state.container;

      if (!api || !container) {
        return;
      }

      api.parse(container);
    });
    return _this;
  }

  var _proto = Parser.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children;
    return _react["default"].createElement("div", {
      className: className,
      ref: this.handleContainer
    }, _react["default"].createElement(_Initialize["default"], {
      onReady: this.handleReady
    }, children({
      handleParse: this.handleParse
    })));
  };

  return Parser;
}(_react.Component);

exports["default"] = Parser;
(0, _defineProperty2["default"])(Parser, "defaultProps", {
  className: undefined
});